import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, compose, legacy_createStore as createStore, StoreEnhancer } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import { persistStore } from 'redux-persist';
import * as Sentry from '@sentry/react';

import { rootEpic } from 'rdx/epic';
import { AppServices, createMiddleware } from 'rdx/middleware';
import { rootReducer } from 'rdx/reducer';
import { historyInstance } from '@provider-portal/common/utils/history';

const isProductionMode = checkProductionMode();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: historyInstance,
});

export const createReduxStore = (appServices: AppServices) => {
  const { allMiddlewares, epicMiddleware } = createMiddleware(appServices);

  let middlewareEnhancers = applyMiddleware(routerMiddleware, ...allMiddlewares);
  if (!isProductionMode) {
    middlewareEnhancers = composeWithDevTools(middlewareEnhancers);
  }

  const sentryEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: () => null,
    actionTransformer: (action) => ({ type: action.type }),
  });
  const store = createStore(
    rootReducer(routerReducer),
    compose(middlewareEnhancers, sentryEnhancer) as StoreEnhancer,
  );
  const persistor = persistStore(store);

  epicMiddleware.run(rootEpic);
  // Created after epics run so they receive the initial LOCATION_CHANGE
  const history = createReduxHistory(store);

  return { store, persistor, history };
};
